import type { SecureClientColumn } from "features/secureUploads/secureUploads";

export const CLIENT_LIST_PAGE_SIZE = 25;

export interface ClientColumn {
  key: SecureClientColumn;
  label: string;
  align: "left" | "center";
}

export const CLIENT_COLUMNS: ClientColumn[] = [
  { key: "name", label: "Client", align: "left" },
  { key: "open_projects", label: "Open Projects", align: "center" },
  { key: "new_files", label: "New Files", align: "center" },
  { key: "contributors", label: "Contributors", align: "center" },
  { key: "latest_activity", label: "Latest Activity", align: "center" },
];

export interface SortState {
  column: SecureClientColumn;
  direction: "asc" | "desc";
}

export const DEFAULT_SORT: SortState = { column: "name", direction: "asc" };

/** The `ordering` the server takes: the column, "-" first when descending. */
export function toOrdering(sort: SortState): string {
  return `${sort.direction === "desc" ? "-" : ""}${sort.column}`;
}

/** A click on a column header: the same column turns around; another one starts
 * A-Z for names and with the most or the newest first for numbers and dates. */
export function nextSort(
  current: SortState,
  column: SecureClientColumn,
): SortState {
  if (current.column === column)
    return { column, direction: current.direction === "asc" ? "desc" : "asc" };
  return { column, direction: column === "name" ? "asc" : "desc" };
}

/** "2 NEW", or nothing when the viewer has opened everything. */
export function newFilesLabel(count: number): string | null {
  return count > 0 ? `${count} NEW` : null;
}

/** "August 2, 2026", or "-" before anything happened. */
export function activityDate(iso: string | null): string {
  if (!iso) return "-";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function pageCount(total: number, pageSize = CLIENT_LIST_PAGE_SIZE) {
  return Math.max(1, Math.ceil(total / pageSize));
}
